import { render } from "./ReceiptVerificationModal.vue?vue&type=template&id=d510e4fc&ts=true"
import script from "./ReceiptVerificationModal.vue?vue&type=script&lang=ts"
export * from "./ReceiptVerificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__